export const LOCAL_STORAGE_LOGGED_USER = "LOCAL_STORAGE_LOGGED_USER";

export const LOCAL_STORAGE_CATEGORY_FILTER = "LOCAL_STORAGE_CATEGORY_FILTER";
export const LOCAL_STORAGE_DATE_FILTER = "LOCAL_STORAGE_DATE_FILTER";
export const LOCAL_STORAGE_SCORE_SORT = "LOCAL_STORAGE_SCORE_SORT";
export const LOCAL_STORAGE_DATE_SORT = "LOCAL_STORAGE_DATE_SORT";

export const POST_LIST_LIMIT = 20;

export const THEME_COLOR = "rgb(251, 0, 91)";

export const COMMENT_LIMIT = 20;

export const DUMMY_PROFILE_PIC_URI = "https://api.adorable.io/avatars/";
export const CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/";



// WEBPACK FOOTER //
// ./src/constants.ts